var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.8866C6.40661 10.8866 5.11328 9.59328 5.11328 7.99995C5.11328 6.40661 6.40661 5.11328 7.99995 5.11328C9.59328 5.11328 10.8866 6.40661 10.8866 7.99995C10.8866 9.59328 9.59328 10.8866 7.99995 10.8866ZM7.99995 6.11328C6.95995 6.11328 6.11328 6.95995 6.11328 7.99995C6.11328 9.03995 6.95995 9.88661 7.99995 9.88661C9.03995 9.88661 9.88661 9.03995 9.88661 7.99995C9.88661 6.95995 9.03995 6.11328 7.99995 6.11328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00022 14.014C5.49355 14.014 3.12688 12.5473 1.50021 10.0006C0.793548 8.90064 0.793548 7.1073 1.50021 6.00064C3.13355 3.45397 5.50022 1.9873 8.00022 1.9873C10.5002 1.9873 12.8669 3.45397 14.4935 6.00064C15.2002 7.10064 15.2002 8.89397 14.4935 10.0006C12.8669 12.5473 10.5002 14.014 8.00022 14.014ZM8.00022 2.9873C5.84688 2.9873 3.78688 4.28064 2.34688 6.54064C1.84688 7.32064 1.84688 8.68064 2.34688 9.46064C3.78688 11.7206 5.84688 13.014 8.00022 13.014C10.1535 13.014 12.2135 11.7206 13.6535 9.46064C14.1535 8.68064 14.1535 7.32064 13.6535 6.54064C12.2135 4.28064 10.1535 2.9873 8.00022 2.9873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye-1.28c8d48af9f5a1c0a6c11313930392e5.svg";
export { ForwardRef as ReactComponent };